import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, of, switchMap } from 'rxjs';
import { environment } from '../../environments/environment';
import AppError from '../../model/app-error';
import { AppType } from '../../model/app-type.model';
import { ApiService } from '../../services/api.service';
import { AppState } from '../index';
import configActions from './config.actions';

@Injectable()
export class ConfigEffects {
  fetchStart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(configActions.fetchStart),
      switchMap(() => {
        switch (environment.app) {
          case AppType.Direct:
            return this.apiService.getConfig().pipe(
              map((data) => configActions.fetchSuccess({ data })),
              catchError((error: AppError) => {
                if (error.type === 'auth' || this.router.url === '/error/auth') {
                  void this.router.navigate(['/error/auth']);
                } else {
                  void this.router.navigate(['/error']);
                }

                return of(configActions.fetchError({ error }));
              }),
            );
          default:
            return this.apiService.getAgentConfig().pipe(
              map((data) => configActions.fetchSuccess({ data })),
              catchError((error: AppError) => {
                if (error.type === 'auth' || this.router.url === '/error/auth') {
                  void this.router.navigate(['/error/auth']);
                } else {
                  void this.router.navigate(['/error']);
                }

                return of(configActions.fetchError({ error }));
              }),
            );
        }
      }),
    ),
  );

  fetchMenuConfigStart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(configActions.fetchMenuConfigStart),
      switchMap(() =>
        this.apiService.getGlobtroterMenu().pipe(
          map((data) => configActions.fetchMenuConfigSuccess({ data })),
          catchError((error: AppError) => {
            if (error.type === 'auth' || this.router.url === '/error/auth') {
              void this.router.navigate(['/error/auth']);
            }

            return of(configActions.fetchMenuConfigError({ error }));
          }),
        ),
      ),
    ),
  );

  fetchGlobtroterUserStart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(configActions.fetchGlobtroterUserStart),
      switchMap(() =>
        this.apiService.getGlobtroterUser().pipe(
          map((data) => configActions.fetchGlobtroterUserSuccess({ data })),
          catchError((error: AppError) => {
            if (error.type === 'auth' || this.router.url === '/error/auth') {
              void this.router.navigate(['/error/auth']);
            }

            return of(configActions.fetchGlobtroterUserError({ error }));
          }),
        ),
      ),
    ),
  );

  fetchGlobtroterConfigStart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(configActions.fetchGlobtroterConfigStart),
      switchMap(() =>
        this.apiService.getGlobtroterConfig().pipe(
          map((data) => configActions.fetchGlobtroterConfigSuccess({ data })),
          catchError((error: AppError) => {
            if (error.type === 'auth' || this.router.url === '/error/auth') {
              void this.router.navigate(['/error/auth']);
            }

            return of(configActions.fetchGlobtroterConfigError({ error }));
          }),
        ),
      ),
    ),
  );

  constructor(private store: Store<AppState>, private apiService: ApiService, private actions$: Actions, private router: Router) {}
}
